import { render, staticRenderFns } from "./slider-carousel.vue?vue&type=template&id=5eceef59&scoped=true"
import script from "./slider-carousel.vue?vue&type=script&lang=js"
export * from "./slider-carousel.vue?vue&type=script&lang=js"
import style0 from "./slider-carousel.vue?vue&type=style&index=0&id=5eceef59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eceef59",
  null
  
)

export default component.exports